
import http from './http-common';

class FabricThreadCountService {
  getAll() {
    return http.get('/fabricThreadCount');
  }
  getFabricThreadCountForList() {
    return http.get('fabricThreadCount/getFabricThreadCountForList');
  }
  get(id) {
    return http.get(`/fabricThreadCount/${id}`);
  }
  
  create(data) {
    return http.post(`/fabricThreadCount/add`, data);
  }

  update(data) {
    console.log('data: ', data);
    return http.put(`/fabricThreadCount/update`, data);
  }
}

export default new FabricThreadCountService();
